import { render, staticRenderFns } from "./AddNewSalesManualModal.vue?vue&type=template&id=226b1b1c&scoped=true&"
import script from "./AddNewSalesManualModal.vue?vue&type=script&lang=js&"
export * from "./AddNewSalesManualModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSalesManualModal.vue?vue&type=style&index=0&id=226b1b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b1b1c",
  null
  
)

export default component.exports